<script setup>
  import { onMounted, ref, watch, provide } from 'vue';
  import NavLink from './components/NavLink.vue';

  const isDarkMode = ref(null);
  provide('isDarkMode', isDarkMode);

  const toggleDarkMode = ()=>{
    isDarkMode.value = !isDarkMode.value;
  }

  watch(isDarkMode, ()=>{
    if (isDarkMode.value){
      document.querySelector('html').classList.add('dark')
      window.localStorage.setItem('lightmode', 'dark')
    } else {
      document.querySelector('html').classList.remove('dark')
      window.localStorage.setItem('lightmode', 'light')
    }
  })

  onMounted(()=>{
    if (window.localStorage.getItem('lightmode') == null){
      isDarkMode.value = window.matchMedia('(prefers-color-scheme: dark)').matches;
    } else {
      isDarkMode.value = window.localStorage.getItem('lightmode') == "dark";
    }
  })


  const mainMenuHidden = ref(true);

  const toggleMainMenu = ()=>{
    mainMenuHidden.value = !mainMenuHidden.value;
  }

  const hideMenu = ()=>{
    mainMenuHidden.value = true;
  }

</script>

<template>
  <div class="flex flex-col w-screen h-screen justify-stretch items-stretch">
    <div :class="[
      'bg-white dark:bg-neutral-900 border-b border-gray-200 dark:border-black shadow-lg',
      'min-h-[4rem] overflow-hidden'
    ] ">
      <div class="header container !py-0 flex gap-8 h-full items-center" v-auto-animate>

        <h2 v-if="$router.currentRoute.value.path != '/'" class="text-xl font-display header-logo whitespace-nowrap">
          <RouterLink to="/" class="text-primary hover:text-primary-hover" @click="hideMenu">
            <img :src="$router.options.base+'/images/logo.svg'" class="inline-block w-8">
            PokéTools
          </RouterLink>
        </h2>

        <div class="max-lg:flex-grow"><!-- spacer--></div>

        <div class="lg:flex-grow place-self-stretch relative">

          <div class="lg:hidden" @click="toggleMainMenu">
            <img :src="$router.options.base+'/images/menu.svg'" class="w-8 m-4 cursor-pointer "/>
          </div>

          <div
            :class="[
              mainMenuHidden ? 'hidden': 'flex',
              'main-menu gap-4',
              'fixed top-16 right-0 w-full flex-col bg-white dark:bg-black z-10 p-8 shadow-xl',
              'lg:static lg:w-auto lg:!flex lg:flex-row lg:items-stretch lg:h-full lg:bg-transparent lg:dark:bg-transparent lg:p-0 lg:shadow-none',
            ]">

            <NavLink v-if="$router.currentRoute.value.path == '/'" tool="Home"/>

            <NavLink tool="StarDex" @click="hideMenu"/>

            <NavLink tool="Movelist Generator" @click="hideMenu"/>

            <NavLink tool="Stat Jiggler" @click="hideMenu"/>

            <NavLink tool="Typing Analyser" @click="hideMenu"/>

            <NavLink tool="Cry Creator" @click="hideMenu"/>
          </div>

        </div>

        <div class="min-w-[2rem]">
          <div class="lightmode-switch min-w-[2rem]" @click="toggleDarkMode">
            <div class="toggle-indicator"></div>
            <div
              class="lightmode-mon reshiram"
              alt="Reshiram, representing light mode"
              title="Swap colours to light mode"
            ></div>
            <div
              class="lightmode-mon zekrom"
              alt="Zekrom, representing dark mode"
              title="Swap colours to dark mode"
              ></div>
          </div>
        </div>

      </div>
    </div>
    <div class="flex-grow overflow-y-auto" v-auto-animate>
      <router-view/>
    </div>
  </div>
</template>
